var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", lg: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("keystore-form-global", {
                attrs: {
                  mode: _vm.mode,
                  id: _vm.id,
                  readonly: !_vm.isEditable,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }